import BuslineActing from '@/modules/buslines/pages/BuslineActing';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/buslines/$buslineId/acting/',
)({
  head: () => ({
    meta: [{ title: 'Execuções da Rota' }],
  }),
  component: function BuslineActingRouter() {
    const { buslineId } = Route.useParams();

    return <BuslineActing buslineId={buslineId} />;
  },
});
